// permissionMap.js

export const ACTION_PERMISSION_MAP = {
  //  rfq
  navigate_to_rfq_automation: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
    buyer_admin: "#/Organization_dashboard/RFQ",
  },

  navigate_to_quick_rfq: {
    menuId: 4,
    buyer: "#/Buyer_dashboard/QuickRFQ",
  },

  //   PR
  navigate_to_pr_automation: {
    menuId: 2,
    buyer: "#/Buyer_dashboard/PR",
    user: "#/User_dashboard/PR",
  },

  // PO
  navigate_to_po_automation: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
    buyer_admin: "#/Organization_dashboard/PO",
    user: "#/User_dashboard/PO",
    vendor: "#/Vendor_dashboard/PO",
  },

  //   Comparison automation
  navigate_to_comparison_automation: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/Comparison",
  },

  navigate_add_comparison: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/Comparison",
  },

  search_comparison: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/Comparison",
  },

  view_specific_comparison: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/Comparison",
  },
  //  GRN
  navigate_to_grn_automation: {
    menuId: 10,
    buyer: "#/GRN_Dashboard/GRN",
    user: "#/GRN_Dashboard/GRN",
  },

  search_grn: {
    menuId: 10,
    buyer: "#/GRN_Dashboard/GRN",
    user: "#/GRN_Dashboard/GRN",
  },

  //  invoice
  navigate_to_merchant_invoice_automation: {
    menuId: 16,
    buyer: "#/Buyer_dashboard/Invoice",
    user: "#/User_dashboard/ApproveInvoice",
    vendor: "#/Vendor_dashboard/Vendor%20Invoice",
  },

  //  3 way matching

  create_twm: {
    menuId: 17,
    buyer: "#/Buyer_dashboard/Matching",
    user: "#/User_dashboard/Matching",
  },

  navigate_to_three_way_matching: {
    menuId: 17,
    buyer: "#/Buyer_dashboard/Matching",
    user: "#/User_dashboard/Matching",
  },
  export_data: {
    menuId: 17,
    buyer: "#/Buyer_dashboard/Matching",
    user: "#/User_dashboard/Matching",
  },

  search_records: {
    menuId: 17,
    buyer: "#/Buyer_dashboard/Matching",
    user: "#/User_dashboard/Matching",
  },

  open_twm_specific_record: {
    menuId: 17,
    buyer: "#/Buyer_dashboard/Matching",
    user: "#/User_dashboard/Matching",
  },


  //   rate contract
  navigate_to_rate_contract: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/rate_contract",
  },
  navigate_create_rate_contract: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/rate_contract",
  },
  
  open_rc_specific_record: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/rate_contract",
  },
  
  convert_rc_to_po: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/rate_contract",
  },


  //   vendor onboarding
  navigate_to_onboarding: {
    menuId: 12,
    buyer: "#/Buyer_dashboard/Invite",
  },

  navigate_to_vendor_compliance_verification: {
    menuId: 14,
    buyer: "#/Buyer_dashboard/PanToCinUploader",
  },

  navigate_to_advance_onboarding: {
    menuId: 14,
    buyer: "#/Buyer_dashboard/verification",
  },

  open_vendor_onboarding_report_analytics: {
    menuId: 14,
    buyer: "#/Buyer_dashboard/Invite",
  },

  //   Master record
  navigate_to_vendor_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Vendors",
    buyer_admin: "#/Organization_dashboard/Vendors",
  },

  navigate_to_item_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Items",
    buyer_admin: "#/Organization_dashboard/Items",
  },

  // Dashboard
  navigate_to_dashboard: {
    menuId: 1,
    buyer: "#/Buyer_dashboard/Dashboard",
    buyer_admin: "#/Organization_dashboard/Dashboard",
    user: "#/User_dashboard/Dashboard",
    vendor: "#/Vendor_dashboard/Dashboard",
  },

  //   Buyer admin
  navigate_to_tax_master: {
    menuId: 21,
    buyer_admin: "#/Organization_dashboard/GstTab",
  },

  navigate_to_cost_center_master: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/CostCenterTab",
  },

  navigate_to_gl_code_master: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/GLTab",
  },

  navigate_to_project_code_master: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/ProjectsTab",
  },

  navigate_to_po_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/Slab",
  },

  navigate_to_pr_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/PRSlab",
  },

  navigate_to_twm_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/twm_slab",
  },

  // buyer admin master record:
  search_item_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Items",
    buyer_admin: "#/Organization_dashboard/Items",
  },

  export_item_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Items",
    buyer_admin: "#/Organization_dashboard/Items",
  },

  add_item_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Items",
    buyer_admin: "#/Organization_dashboard/Items",
  },

  search_vendor_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Vendors",
    buyer_admin: "#/Organization_dashboard/Vendors",
  },

  search_tax_master: {
    menuId: 21,
    buyer_admin: "#/Organization_dashboard/GstTab",
  },

  add_tax_master: {
    menuId: 21,
    buyer_admin: "#/Organization_dashboard/GstTab",
  },

  // buyer_admin Accounting codes

  search_cost_center: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/CostCenterTab",
  },
  add_cost_center: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/CostCenterTab",
  },

  search_gl_code: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/GLTab",
  },
  add_gl_code: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/GLTab",
  },

  search_project_code: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/ProjectsTab",
  },
  add_project_code: {
    menuId: 22,
    buyer_admin: "#/Organization_dashboard/ProjectsTab",
  },

  // buyer_admin_approverRange

  search_pr_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/PRSlab",
  },
  add_pr_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/PRSlab",
  },

  search_po_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/Slab",
  },
  add_po_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/Slab",
  },

  search_twm_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/twm_slab",
  },
  add_twm_approver_range: {
    menuId: 23,
    buyer_admin: "#/Organization_dashboard/twm_slab",
  },

  // user management

  navigate_users: {
    menuId: 20,
    buyer_admin: "#/Organization_dashboard/Buyers",
  },

  search_users: {
    menuId: 20,
    buyer_admin: "#/Organization_dashboard/Buyers",
  },

  add_buyer: {
    menuId: 20,
    buyer_admin: "#/Organization_dashboard/Buyers",
  },
  add_user: {
    menuId: 20,
    buyer_admin: "#/Organization_dashboard/Buyers",
  },
  export_users: {
    menuId: 20,
    buyer_admin: "#/Organization_dashboard/Buyers",
  },

  //Buyer:

  navigate_to_material_requirement_planning: {
    menuId: 11,
    buyer: "#/Buyer_dashboard/MRP",
  },

  // vendor
  navigate_to_vendor_user_management: {
    vendor: "#/Vendor_dashboard/Users",
  },
  navigate_to_vendor_bid_submission: {
    vendor: "#/Vendor_dashboard/RFQ",
  },

  navigate_to_vendor_dashboard: {
    menuId: 1,
    vendor: "#/Vendor_dashboard/Dashboard",
  },

  navigate_to_vendor_invoice: {
    vendor: "#/Vendor_dashboard/InvoiceProcess",
  },

  add_invoice: {
    vendor: "#/Vendor_dashboard/InvoiceProcess",
  },

  search_invoices: {
    vendor: "#/Vendor_dashboard/InvoiceProcess",
  },
  open_specific_invoice: {
    vendor: "#/Vendor_dashboard/InvoiceProcess",
  },

  navigate_to_vendor_search: {
    vendor: "#/Vendor_dashboard/Users",
  },

  add_vendor_user: {
    vendor: "#/Vendor_dashboard/Users",
  },

  export_vendor_users: {
    vendor: "#/Vendor_dashboard/Users",
  },

  submit_specific_bid: {
    vendor: "#/Vendor_dashboard/RFQ",
  },

  search_bid:{
     vendor: "#/Vendor_dashboard/RFQ",
  },

   export_bid_submission:{
     vendor: "#/Vendor_dashboard/RFQ",
  },

  // user

  navigate_to_user_pr: {
    menuId: 2,
    user: "#/User_dashboard/PR",
  },

  navigate_to_user_invoice_automation: {
    menuId: 17,
    user: "#/User_dashboard/Matching",
    buyer: "#/Buyer_dashboard/Matching",
  },

  navigate_to_user_po_automation: {
    menuId: 19,
    user: "#/User_dashboard/PO",
  },

  navigate_to_user_dashboard: {
    menuId: 1,
    user: "#/User_dashboard/Dashboard",
  },

  navigate_to_user_chat: {
    user: "#/Chat_Dashboard/Chat",
  },
  navigate_to_user_invoice: {
    user: "#/User_dashboard/ApproveInvoice",
  },

  navigate_to_user_onboarding_approval: {
    user: "#/User_dashboard/vendor_approval",
  },

  navigate_to_tracker_pending: {
    user: "#/User_dashboard/vendor_approval",
  },
  // PR

  open_pending_prs: {
    menuId: 2,
    user: "#/User_dashboard/PR",
    buyer: "#/Buyer_dashboard/PR",
    buyer_admin: "#/Organization_dashboard/PR",
  },

  create_new_pr: {
    menuId: 2,
    user: "#/User_dashboard/PR",
  },

  edit_my_pr: {
    menuId: 2,
    user: "#/User_dashboard/PR",
  },

  approve_pr: {
    menuId: 2,
    user: "#/User_dashboard/PR",
  },
  show_pr_status: {
    menuId: 2,
    buyer: "#/Buyer_dashboard/PR",
    user: "#/User_dashboard/PR",
  },
  view_pr_history: {
    menuId: 2,
    buyer: "#/Buyer_dashboard/PR",
    user: "#/User_dashboard/PR",
  },

  open_specific_pr: {
    menuId: 2,
    buyer: "#/Buyer_dashboard/PR",
    user: "#/User_dashboard/PR",
  },

  search_pr: {
    menuId: 2,
    buyer: "#/Buyer_dashboard/PR",
    user: "#/User_dashboard/PR",
  },
  // RFQ

  create_rfq_from_pr: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },

  open_pending_rfqs: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },
  send_rfq_to_vendors: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },
  track_rfq_responses: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },

  compare_vendor_quotations: {
    menuId: 6,
    buyer: "#/Buyer_dashboard/Comparison",
  },

  open_specific_rfq: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },

  search_rfq: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },

  export_rfq: {
    menuId: 18,
    buyer: "#/Buyer_dashboard/RFQ",
  },

  // PO
  create_po: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
  },
  open_pending_pos: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
  },
  track_po_status: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
  },
  view_po_history: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
  },

  search_po_details: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
  },

  open_specific_po: {
    menuId: 19,
    buyer: "#/Buyer_dashboard/PO",
  },
  // GRN

  create_grn: {
    menuId: 10,
    user: "#/GRN_Dashboard/GRN/?action=create",
  },
  open_pending_grns: {
    menuId: 10,
    buyer: "#/GRN_Dashboard/GRN",
    user: "#/GRN_Dashboard/GRN",
  },
  view_grn_history: {
    menuId: 10,
    buyer: "#/GRN_Dashboard/GRN",
    user: "#/GRN_Dashboard/GRN",
  },

  //Merchant Invoice

  upload_merchant_invoice: {
    menuId: 16,
    user: "#/User_dashboard/Invoice/?action=create",
  },
  extract_invoice_data: {
    menuId: 16,
    user: "#/User_dashboard/Invoice/?action=download",
    buyer: "#/Buyer_dashboard/Invoice/?action=download",
  },
  validate_invoice_fields: {
    menuId: 16,
    buyer: "#/Buyer_dashboard/Invoice",
  },
  generate_accounts_payable_entry: {
    menuId: 16,
    user: "#/User_dashboard/ApproveInvoice",
  },

  //Vendor master
  export_vendor_master: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Vendors",
    buyer_admin: "#/Organization_dashboard/Vendors",
  },

  search_vendor_details: {
    menuId: 21,
    buyer: "#/Buyer_dashboard/Vendors",
    buyer_admin: "#/Organization_dashboard/Vendors",
  },
};
